export const separateThousands = (
  value: number | string,
  separator: string
) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};
